import React from 'react'

export default function CloseIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M2 14L14 2" stroke="#AAAAAA" strokeWidth="2" />
      <path d="M14 14L2 2" stroke="#AAAAAA" strokeWidth="2" />
    </svg>
  )
}
